import { businessAreasRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useDisableBusinessArea = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    businessAreasRepo.disableBusinessArea(id),
  );
